import React, { Component } from 'react'
import Chart from '../components/Chart'
import { connect, ConnectedProps } from 'react-redux'
import { fetchMagnetometer, changeMagnetometer } from '../actions'
import { BLACK } from '../constants/colors'
import { GEO_MAG_URLS, Option } from '../constants/urls'
import { Names } from '../constants/names'

const SCALE = 100

const findId = function (name: string) {
  return Object.keys(Names).find((key) => Names[key] === name)
}

const GEO_MAG_CHART = {
  type: 'line',
  lineWidth: 1,
  color: BLACK,
}

const GEO_MAG_SETTINGS = {
  unit: ' nT',
  xPlotLines: [],
}

interface GeoMagContainerProps extends PropsFromRedux {}

class GeoMagContainer extends Component<GeoMagContainerProps> {
  componentDidMount() {
    const { fetchMagnetometer, period } = this.props
    fetchMagnetometer(GEO_MAG_URLS, period)
  }

  getMagnetometerSettings() {
    const { changeMagnetometer } = this.props
    // ToDo: Highcharts as Type definitions of its own. Get rid of ignores.
    return {
      ...GEO_MAG_SETTINGS,
      series: {
        events: {
          show: function () {
            // @ts-ignore
            const chart = this.chart
            const series = chart.series
            let i = series.length
            let otherSeries
            while (i--) {
              otherSeries = series[i]
              if (otherSeries !== this && otherSeries.visible) {
                otherSeries.hide()
              }
            }
            // @ts-ignore
            changeMagnetometer(findId(this.name))
            // @ts-ignore
            this.yAxis.setExtremes(this.dataMin - SCALE, this.dataMax + SCALE, true, false)
          },
          afterAnimate: function () {
            // @ts-ignore
            if (this.visible) {
              // @ts-ignore
              this.yAxis.setExtremes(this.dataMin - SCALE, this.dataMax + SCALE)
            }
          },
          legendItemClick: function () {
            // @ts-ignore
            if (this.visible) {
              return false
            }
          },
        },
      },
    }
  }

  render() {
    const { error, magnetometers, selectedMagnetometer } = this.props
    const firstSeries = magnetometers && magnetometers.slice(0, 1)[0]

    const series = {
      ...GEO_MAG_CHART,
      name: firstSeries && Names[firstSeries.key], // ToDo: Cleanup this firstSeries && -stuff
      data: firstSeries && firstSeries.data,
      visible: firstSeries && firstSeries.key === selectedMagnetometer,
    }

    const multiSeries =
      magnetometers &&
      magnetometers.slice(1).map((mag: any) => {
        return {
          ...GEO_MAG_CHART,
          name: Names[mag.key],
          data: mag.data,
          visible: mag.key === selectedMagnetometer,
        }
      })

    return (
      <div>
        <Chart
          id="magnetometer"
          title="Magnetometer X values"
          series={series}
          multiSeries={multiSeries}
          settings={this.getMagnetometerSettings()}
          error={error}
        />
        <div className="source-copyright">
          Magnetometer data source <a href="https://space.fmi.fi/image/realtime/UT/">FMI</a>
        </div>
      </div>
    )
  }
}

const mapDispatch = {
  fetchMagnetometer,
  changeMagnetometer,
}

interface GeoMagContainerState {
  magnetometers: any
  currentTime: Date
  period: Option
  selectedMagnetometer: any
}

function mapState(state: GeoMagContainerState) {
  const { magnetometers, currentTime, period, selectedMagnetometer } = state
  return {
    magnetometers: magnetometers.periodData,
    currentTime: currentTime,
    error: magnetometers.error,
    period: period,
    selectedMagnetometer: selectedMagnetometer,
  }
}

const connector = connect(mapState, mapDispatch)

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(GeoMagContainer)
